// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { createResponseObj, generateHeaders } from '..'
import { stripeBaseUrl } from '.'


type CreateSetupIntentResponse = (SuccessResponse & {
    clientSecret: string

    paymentId?: string
    paymentMethodId?: string
}) | FailedResponse

// (ExpressPaymentType[number] | 'credit_card')[]

export class CreateSetupIntentRequest extends Request {
    public static readonly types = ['credit_card', 'apple_pay', 'google_pay'] as const

    private constructor(init?: RequestInit) { super(`${stripeBaseUrl}/payment`, init) }
    static async init(
        params?: {
            type?: (CreditCard | ApplePay | GooglePay)['type'],
            intentType?: 'setup_intent' | 'payment_intent',
            amount?: number
        },
        init?: RequestInit
    ) {
        return new CreateSetupIntentRequest({
            ...init,
            method: 'POST',
            headers: await generateHeaders("Clerk-Token", init?.headers),
            body: params ? JSON.stringify({
                type: this.types.find((t) => t === params.type) || 'credit_card',
                intentType: params.intentType || 'setup_intent',
                amount: params.amount || 0
            }) : undefined
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<{ clientSecret: string, paymentId?: string, paymentMethodId?: string }> {
        const response = await fetch(this)
        const data = createResponseObj<CreateSetupIntentResponse>(await response.json())
        console.info("Get Setup Intent Results:", data)

        switch (data.status) {
            case 'successful': return data
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}

